// extracted by mini-css-extract-plugin
module.exports = {"tags":"a10a3f92e9--tags--ybhTH","tags_wrapper":"a10a3f92e9--tags_wrapper--Sy5H8","tags_item":"a10a3f92e9--tags_item--tyk4W"};